<template>
  <v-container class="white-wrapper" fluid>
    <div class="last-item-one content-wrapper">
      <div class="text-center font-60 font-weight-bold mb-5">
        스왑 신청 완료
      </div>
      <v-divider class="my-5"></v-divider>
      <div class="text-center font-44 last-item-one">
        ・ 스왑은 월-금, 10시-18시 사이에 순차적으로 진행됩니다.<br />
        ・ 스왑 결과는 [PLI 내역] 과 [트랜잭션 내역] 페이지에서 확인 가능합니다.
      </div>
      <v-btn
        class="bottom-btn"
        color="primary"
        tile
        block
        x-large
        height="56px"
        to="/home"
      >
        홈으로
      </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  created() {
    if (!this.$route.params.hash) this.$router.replace('/home')
  }
}
</script>

<style lang="scss" scoped>
.bottom-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  position: fixed;
  z-index: 10;
  left: 0;
  bottom: 56px;
  height: 56px;
}
.white-wrapper {
  display: flex;

  align-items: center;
}
.content-wrapper {
  padding: 1.3rem;
}
</style>
